module.exports = __webpack_public_path__ + "static/57109796_2301522480120086_590235214932869120_o-210fcc3be8460a3a538e0f38bf1949bd.jpg";